export default {
  existing_documents: {
    description:
      'Du har allerede uploadet følgende dokumenter. Vælg et, og tryk på send, eller upload i stedet et nyt dokument.',
    sides: {
      front: 'Forside',
      back: 'Bagside',
    },
    created_at: 'Uploadet: {{date}}',
    expires_at: 'Udløber: {{date}}',
  },
  document_types: {
    owner_document: 'Ejerens identitetsdokument',
    business_document: 'Virksomhedsdokument',
  },
  form: {
    document_type: {
      label: 'Virksomhedsdokumentation',
      placeholder: 'Vælg dokumenttype',
      options: {
        vat_registration: 'Momsregistrering',
        trade_registration: 'Erhvervsregistrering',
        trade_license: 'Næringsbevis',
        commercial_register_extract: 'Udskrift fra handelsregisteret',
        financial_statements: 'Regnskab',
        other: 'Andet',
      },
    },
    front: {
      label: 'Dokumentets forside',
    },
    back: {
      label: 'Dokumentets bagside (valgfrit for visse dokumenter)',
    },
    expires_at: {
      label: 'Dokumentets udløbsdato',
      placeholder: 'Vælg udløbsdato',
    },
  },
  buttons: {
    select_file: 'Vælg fil',
    next: 'Næste',
    back: 'Bagside',
    send: 'Send',
    upload_new: 'Upload nyt dokument',
    use_existing: 'Brug et uploadet dokument',
  },
};
